import React, { useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ImportDataService from "../../../services/OrderingServices/ImportDataService";
import toast from "react-hot-toast";
import {
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const ImportProductTemplate = () => {
  const [fileBlob, setFileBlob] = useState(null); // store blob directly
  const [fileUrl, setFileUrl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDownloadTemplate = async () => {
    try {
      if (fileBlob && fileUrl) {
        // Already downloaded; just open modal
        setModalOpen(true);
        return;
      }

      setLoading(true);
      const response = await ImportDataService.getTemplate();

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      setFileBlob(blob);
      setFileUrl(url);

      // Trigger the first download immediately
      const link = document.createElement("a");
      link.href = url;
      link.download = "Product_Import_Template.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Template downloaded successfully!");
      setModalOpen(true);
    } catch (error) {
      console.error(error);
      toast.error("Failed to download template!");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadAgain = () => {
    if (!fileBlob) {
      toast.error("No cached file found!");
      return;
    }

    // Create a new object URL each time for safety
    const newUrl = window.URL.createObjectURL(fileBlob);
    const link = document.createElement("a");
    link.href = newUrl;
    link.download = "Product_Import_Template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Optional: revoke after short delay
    setTimeout(() => URL.revokeObjectURL(newUrl), 1000);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Download Import Template" pageTitle="Settings" />
      </div>

      <div className="d-flex justify-content-center align-content-center align-items-center mt-0 mt-lg-5">
        <Card className="col-12 col-lg-6 col-md-6">
          <CardBody>
            <h4 className="mb-3 text-center">Download Import Template</h4>
            <p>
              Download the official <strong>product import template</strong> to
              upload bulk product data easily. Fill it according to the provided
              format before importing.
            </p>
            <ul className="mb-4">
              <li>
                Click the <strong>Download</strong> button below.
              </li>
              {/* <li>
                Once downloaded, the file is cached — next clicks won’t re-hit
                the API.
              </li> */}
              <li>Use the same file to upload product details.</li>
            </ul>
            <div className="text-center">
              <button
                className="btn btn-success"
                disabled={loading}
                onClick={handleDownloadTemplate}
              >
                {loading ? "Downloading..." : "Download Template"}
              </button>
            </div>
          </CardBody>
        </Card>
      </div>

      {/* <Modal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        static
        backdrop={true}
      >
        <ModalHeader toggle={() => setModalOpen(false)}>
          Product Import Template
        </ModalHeader>
        <ModalBody>
          {fileBlob ? (
            <div className="text-center">
              <p className="mb-3">
                Your import template is ready. You can download it again anytime
                during this session.
              </p>
              <button className="btn btn-primary" onClick={handleDownloadAgain}>
                <i className="ri-download-2-line me-1"></i> Download Again
              </button>
            </div>
          ) : (
            <p className="text-danger text-center">
              No cached file available to download.
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-secondary"
            onClick={() => setModalOpen(false)}
          >
            Close
          </button>
        </ModalFooter>
      </Modal> */}
    </div>
  );
};

export default ImportProductTemplate;
